import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

/**
 * Utilisation :
 *   <Route element={<PrivateRoute permission="pages.manage" />}>
 *     <Route path="/admin/pages" element={<PagesManager />} />
 *   </Route>
 */
export function PrivateRoute({ children, permission }) {
  const { user, loading, can } = useAuth();

  if (loading) {
    return <p>Chargement...</p>;
  }

  if (!user) {
    return <Navigate to="/admin/connexion" replace />;
  }

  if (permission && !can(permission)) {
    return <Navigate to="/admin" replace />;
  }

  return children;
}
